import styled from "styled-components";

export const FooterTitleTextWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding-bottom: 30px;
`;
export const FooterTitle = styled.div`
  font-size: 24px;
  @media (min-width: 744px) {
    font-size: 18px;
    font-weight: 400;
  }
`;

export const FooterTitleLine = styled.div`
  border: 1px solid #214162;
  width: 100%;
`;
